<template>
    <div class="lectureTypeLayout">
        <slot></slot>
    </div>
</template>
<script>
    export default {
        name: "LectureTypeLayout"
    }
</script>